import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faClock } from '@fortawesome/free-regular-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MDBCol, MDBRow } from 'mdbreact';
import React from 'react';
import { Card } from 'react-rainbow-components';
import { Agenda, Info, propsPreview } from '../../interfaces/Info_interface';
import { createMarkup } from './MarkUp';

const Preview: React.FC<propsPreview> = (props: propsPreview) => {
  console.log(props);
  return (
    <>
      <MDBCol className="text-center mb-4 mt-5">
        <hr />
        <h1 className="font-size-1vw">Preview</h1>
      </MDBCol>
      <MDBRow>
        {props.Image !== '' ? (
          <MDBCol size={'12'}>
            <Card className="mb-4 ">
              <img
                src={props.Image}
                className="w-100"
                alt="Foto Actu"
                style={{ height: '450px', width: '950px' }}
              />
            </Card>
          </MDBCol>
        ) : (
          <MDBCol size={'12'}>
            <div className="w-100 rounded z-depth-1-half mb-4 mt-5"></div>
          </MDBCol>
        )}
      </MDBRow>
      <MDBRow>
        <MDBCol>
          <h6
            className="font-weight-bold deep-orange-text mt-2"
            style={{ fontSize: '1vw' }}
          >
            <FontAwesomeIcon
              icon={faMapMarkerAlt}
              className="pr-2"
              style={{ width: '1.5vw' }}
            />
            {props.Commune.name}
          </h6>
        </MDBCol>
        <MDBCol className="text-right">
          <h6
            className="font-weight-bold dark-grey-text mt-2"
            style={{ fontSize: '1vw' }}
          >
            <FontAwesomeIcon
              icon={faClock}
              className="pr-2"
              style={{ width: '1.5vw' }}
            />
            {props.DateEvenement !== undefined
              ? props.DateEvenement.slice(0, -3)
              : props.DateDebut.slice(0, -3)}
          </h6>
        </MDBCol>
      </MDBRow>
      <MDBRow>
        <MDBCol>
          <h3
            className="font-weight-bold mb-3 p-0 mt-3"
            style={{ fontSize: '1.3vw' }}
          >
            {props.Titre}
          </h3>
        </MDBCol>
      </MDBRow>
      <MDBRow>
        <MDBCol size={'12'}>
          <div
            className="dark-grey-text mb-5"
            dangerouslySetInnerHTML={createMarkup(props.TextComplet)}
            style={{ fontSize: '1.1vw' }}
          />
        </MDBCol>
      </MDBRow>
    </>
  );
};
export default Preview;
